import awsConfigProd from './aws-exports.prod'
import awsConfig from './aws-exports'

const prodDomains = [
    'https://webapp.waterguru.com',
    'https://webapp.waterguru-prod.com'
]

const MODE = (~prodDomains.indexOf(location.origin) && process.env.NODE_ENV === 'production') ? 'prod' : 'qa'
const PREFIX = (MODE === 'prod') ? 'prod-' : 'qa-'
const CONFIG = (MODE === 'prod') ? awsConfigProd : awsConfig

export { PREFIX, MODE }
export default CONFIG
